/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_BOXES } from "../graphql/getBoxes.query";
import { GET_CURRENCY_EXCHANGE_RATE } from "../graphql/getCurrencyExchangeRateProvider.query";
import appCardConfig from "../config/appCard.config.json";
import moment from "moment-timezone";
import { toHeaderCase } from "js-convert-case";
import header from "../config/header.config.json";
import { CurrencyConversion, appendExpiredItemsRemovedData } from "../../../common";
import * as changeCase from "change-case";
import toast from "react-hot-toast";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { GET_BOX } from "../graphql/getBox.query";
import { GET_BOX_LIST } from "../graphql/getBoxList.query";

const is = require("is_js");
const isVideo: any = /\.(mp4|mov|avi|avchd|flv|f4v|swf|mkv|webm|html5)$/i;
const isYoutubeVideo: any =
  /^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/i;

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetBoxesMethods extends IPluginMethodMap {
  getBoxes(args?: any): Promise<any>;
}

export class GetBoxesService implements IAgentPlugin {
  readonly methods: IGetBoxesMethods;
  private exchangeRate: any = 1;

  constructor() {
    this.methods = {
      getBoxes: this.getBoxes.bind(this),
    };
  }

  async getBoxes(args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageService = StorageModule.getInstance();
    console.log(args?.year);
    let boxFilter = {
      ...(args?.payload?.id && { user: { eq: args?.payload?.id } }),
      ...(args?.payload?.costumeID && {
        costumeID: { eq: args.payload?.costumeID },
      }),
    };
    try {
      if (client) {
        const res = await client.query({
          query: GET_BOX,
          variables: {
            filter: boxFilter,
            options: {
              sort: {
                order: "desc",
                field: "createdAt",
              },
              skip: 0,
              limit: 0,
            },
          },
          fetchPolicy: "network-only",
        });

        const _res = await client.query({
          query: GET_CURRENCY_EXCHANGE_RATE,
          fetchPolicy: "network-only",
        });
        let groupData = [],
          groupResData = [];
        if (res?.data?.getBoxes?.content[0]?.groupId) {
          const _resGroup = await client.query({
            query: GET_BOX_LIST,
            variables: {
              filter: {
                groupId: res?.data?.getBoxes?.content[0]?.groupId,
              },
              options: {
                sort: {
                  order: "desc",
                  field: "createdAt",
                },
                skip: 0,
                limit: 0,
              },
            },
            fetchPolicy: "network-only",
          });
          (groupResData = _resGroup),
            (groupData = this.formatUserTable(
              _resGroup?.data?.getBoxes?.content
            ));
        }

        if (_res?.data?.getCurrencyExchangeRate) {
          storageService.set(
            "currencyExchangeLocal",
            _res?.data?.getCurrencyExchangeRate,
            "local"
          );
          storageService.set(
            "currencyExchangeSession",
            _res?.data?.getCurrencyExchangeRate,
            "session"
          );
        }
        this.exchangeRate = res?.data?.getCurrencyExchangeRate?.conversion_rate;
        let payloadArray: any = [];
        let istransferred = false;
        let groupId: string = "";
        if (
          res?.data?.getBoxes?.content &&
          is.not.empty(res?.data?.getBoxes?.content)
        ) {
          for (let obj of res?.data?.getBoxes?.content) {
            if (obj && is.existy(obj) && is.not.empty(obj)) {
              groupId = obj?.groupId ?? "";
              console.log("obj=>", obj);
              obj?.boxTxes.forEach((object: any) => {
                if (object?.action === "pre_bookedAmount_Transferred") {
                  istransferred = true;
                }
              });
            }
          }
        }

        if (
          res?.data?.getBoxes?.content &&
          is.not.empty(res?.data?.getBoxes?.content)
        ) {
          for (let obj of res?.data?.getBoxes?.content) {
            if (obj && is.existy(obj) && is.not.empty(obj)) {
              if (!obj?.isPreBooking) {
                payloadArray.push({
                  presentationStatus: obj?.presentation?.status,
                  ...this.formatData(
                    obj,
                    args?.year,
                    res?.data?.getBoxes?.content
                  ),
                  bandCurrency: res?.data?.getCurrencyExchangeRate?.currency,
                });
              } else {
                if (!istransferred) {
                  payloadArray.push({
                    presentationStatus: obj?.presentation?.status,
                    ...this.formatData(
                      obj,
                      args?.year,
                      res?.data?.getBoxes?.content
                    ),
                    bandCurrency: res?.data?.getCurrencyExchangeRate?.currency,
                  });
                }
              }
            }
          }
        }
        console.log(payloadArray, "payloadArray");
        const filteredArray = payloadArray;
        console.log(filteredArray, "filteredArray");
        if (filteredArray.length === 0)
          toast.error("Costume not reserved for the upcoming carnival");
        console.log("groupData", groupData);
        return {
          groupId,
          data: filteredArray,
          groupData: groupData,
          groupResData: groupResData,
          initialData: this.initialData(res?.data?.getBoxes?.content[0]),
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        const minDownPaymentSum = (item?.items ?? []).reduce(
          (sum: number, currentItem: any) => {
            const downPayment = parseFloat(
              currentItem?.costumeValue?.minDownPayment || "0"
            );
            return sum + downPayment;
          },
          0
        );

        const formattedItems = (item?.items ?? []).map((itm: any) => ({
          costumeType: itm?.costumeType?.id ?? "",
          costumeFeature: itm?.costumeFeature?.id ?? "",
          costumeAttribute: itm?.costumeAttribute?.id ?? "",
          costumeValue: itm?.costumeValue?.id ?? "",
        }));

        return {
          id: item?._id,
          sectionName: item?.section?.name ?? "Null",
          sectionOptTypeName: item?.section?.costumeTypes[0]?.name ?? "-",
          totalAmt: item?.totalAmount ?? "0",
          amountPaid: item?.amountPaid ?? "0",
          deleteIcon: true,
          discountedAmount: 0,
          content: item,
          minDownPayment: minDownPaymentSum,
          items: {
            presentation: item?.presentation?.id ?? "",
            section: item?.section?.id ?? "",
            items: formattedItems,
          },
        };
      });
    console.log("_rowData106", _rowData);
    return _rowData;
  }

  private initialData(data: any) {
    console.log(data);
    return {
      isVIP: data?.isVIP,
      isOpted: data?.delivery?.isOpted,
      deliveryOptions: header?.options,
      partner: data?.delivery?.partner,
      status: data?.delivery?.status,
      trackingId: data?.delivery?.trackingId,
      cityName: data?.address?.city ?? data?.user?.mailAddress?.city,
      address:
        data?.address?.addressLine1 ??
        data?.user?.mailAddress?.addressLine1 ??
        data?.user?.address?.addressLine1,
      delegateName: data?.delegateName,
      availableTime: data?.availableTime,
    };
  }

  private pushListItem = (
    listItems: any,
    index: number,
    title: string,
    subtitle: string
  ) => {
    if (subtitle && is.existy(subtitle)) {
      listItems.push({
        key: index.toString(),
        icon: appCardConfig?.listItems?.icon,
        title: title,
        subtitle: subtitle,
      });
    }

    return listItems;
  };

  private getListItems = (data: any) => {
    let listItems: any = [];
    let index = 0;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.sectionName,
      data?.section?.name
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.costumeID,
      data?.costumeID
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.masqID,
      data?.user?.vuid
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.paymentStatus,
      data?.paymentStats && data?.paymentStats.toLowerCase() === "unpaid"
        ? "DownPayment Due"
        : data?.paymentStats
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.totalAmount,
      `TT$ ${data?.totalAmount} / US$ ${data?.totalAmountInUSD}`
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.receivedAmount,
      `TT$ ${data?.amountPaid ?? 0} / US$ ${data?.amountPaidInUSD ?? 0}`
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.remainingAmount,
      `TT$ ${(data?.totalAmount - (data?.amountPaid ?? 0))
        .toFixed(2)
        .toString()} / US$ ${(
        data?.totalAmountInUSD - (data?.amountPaidInUSD ?? 0)
      )
        .toFixed(2)
        .toString()}`
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.delegateName,
      data?.delegateName
    );
    index++;

    return listItems;
  };

  private getAllSectionImages = (costumeType: any, items: any[] = []) => {
    let imagesArr: any = [];

    // 1. Add images from selected costume options (overall costumes)
    if (items && Array.isArray(items)) {
      for (let item of items) {
        const attributeImages = item?.costumeAttribute?.images;
        if (attributeImages && Array.isArray(attributeImages)) {
          for (let obj of attributeImages) {
            if (obj && is.existy(obj) && !imagesArr.some((img: any) => img.src === obj)) {
              imagesArr.push({
                type: isVideo.test(obj) || isYoutubeVideo.test(obj) ? "video" : "img",
                src: obj,
              });
            }
          }
        }
      }
    }

    // 2. Add main costume images only if no option images exist
    if (imagesArr.length === 0 && costumeType?.images && Array.isArray(costumeType?.images)) {
      for (let obj of costumeType.images) {
        if (obj && is.existy(obj)) {
          if (!imagesArr.some((img: any) => img.src === obj)) {
            imagesArr.push({
              type: isVideo.test(obj) || isYoutubeVideo.test(obj) ? "video" : "img",
              src: obj,
            });
          }
        }
      }
    }

    return imagesArr;
  };

  private getTableData = (payload: any, data: any) => {
    if (!data) {
      return null;
    }

    let arrayItems: any = [];
    let index = 0;

    data?.map((item: any) => {
      if (item && is.existy(item) && is.not.empty(item)) {
        arrayItems.push({
          key: index,
          option: item?.costumeFeature?.name ?? "-",
          desc: item?.costumeFeature?.desc,
          attribute: item?.costumeAttribute?.name ?? "-",
          value: item?.costumeValue?.name ?? "-",
          images: item?.costumeAttribute?.images ?? item?.costumeValue?.images ?? [],
          cost: item?.costumeValue?.topupPrice ?? "-",
        });
        index++;
      }
    });

    arrayItems.push({
      key: index,
      option: "Total",
      attribute: "",
      value: "",
      images: [],
      cost: `TT$ ${payload?.totalAmount} / US$ ${CurrencyConversion(
        this.exchangeRate,
        payload?.totalAmount
      )}`,
    });

    return {
      ...appCardConfig?.table,
      data: arrayItems,
    };
  };

  private getInvoiceData = (data: any) => {
    let arrayItems: any = [];
    let index = 0;

    const _getPaymentMode = (item: any) => {
      if (is.existy(item?.payMethod) && is.existy(item?.mode)) {
        return item?.payMethod + " / " + item?.mode;
      } else if (is.existy(item?.payMethod)) {
        return item?.payMethod;
      } else if (is.existy(item?.mode)) {
        return item?.mode;
      } else {
        return "-";
      }
    };

    data?.map((item: any) => {
      if (item && is.existy(item) && is.not.empty(item)) {
        arrayItems.push({
          key: index,
          date: moment(item?.createdAt).format("MMM D, YYYY, h:mm:ss A") ?? "",
          mode: _getPaymentMode(item),
          amount: `TT$ ${item?.amount} / US$ ${CurrencyConversion(
            this.exchangeRate,
            item?.amount
          )}`,
          status: item?.status ?? "-",
          reason: item?.errorMessage ?? item?.resolutionStatus,
        });
        index++;
      }
    });

    arrayItems = arrayItems.sort((a: any, b: any) => {
      return new Date(b.date) - new Date(a.date);
    });

    return {
      ...appCardConfig?.invoice,
      data: arrayItems,
    };
  };

  private getJourneyChildData(item: any) {
    const data: any = [];
    let index: number = 0;

    if (
      item?.actionContent?.deliveredBy &&
      is.existy(item?.actionContent?.deliveredBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.deliveredBy,
        subTitle: item?.actionContent?.deliveredBy,
      });
    } else if (
      item?.actionContent?.purgedBy &&
      is.existy(item?.actionContent?.purgedBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.purgedBy,
        subTitle: item?.actionContent?.purgedBy,
      });
    } else if (
      item?.actionContent?.generatedBy &&
      is.existy(item?.actionContent?.generatedBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.generatedBy,
        subTitle: item?.actionContent?.generatedBy,
      });
    } else if (
      this.getUserName(item?.user) &&
      is.existy(this.getUserName(item?.user))
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.by,
        subTitle: this.getUserName(item?.user) ?? "",
      });
    }

    if (item?.actionContent?.currency && item?.action !== "expired-items-removed") {
      let str = "";
      if (
        item?.actionContent?.actualPayment?.currency !==
          item?.actionContent?.currency &&
        is.existy(item?.actionContent?.actualPayment?.currency) &&
        is.existy(item?.actionContent?.currency)
      ) {
        str = `US$ ${
          item?.actionContent?.actualPayment?.amount ?? "0.00"
        } / TT$ ${item?.actionContent?.amount ?? "0.00"}`;
      } else {
        str = `TT$ ${item?.actionContent?.amount ?? "0.00"}`;
      }

      data.push({
        key: index++,
        title: appCardConfig?.journey?.amount,
        subTitle: str,
      });
    }

    const _getReason = () => {
      if (
        is.existy(item?.reason) &&
        is.existy(item?.actionContent?.resolutionStatus)
      ) {
        return item?.reason + " / " + item?.actionContent?.resolutionStatus;
      } else if (is.existy(item?.actionContent?.resolutionStatus)) {
        return item?.actionContent?.resolutionStatus;
      } else if (is.existy(item?.reason)) {
        return item?.reason;
      }
    };

    if (_getReason() && is.existy(_getReason())) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.reason,
        subTitle: _getReason(),
      });
    }

    if (item?.action === "expired-items-removed") {
      index = appendExpiredItemsRemovedData(data, item, appCardConfig, index);
    }

    if (
      item?.actionContent?.payMethod &&
      is.existy(item?.actionContent?.payMethod)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.method,
        subTitle: item?.actionContent?.payMethod,
      });
    }

    if (item?.actionContent?.mode && is.existy(item?.actionContent?.mode)) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.mode,
        subTitle: item?.actionContent?.mode,
      });
    }

    if (item?.actionContent?.status && is.existy(item?.actionContent?.status)) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.status,
        subTitle: item?.actionContent?.status,
      });
    }

    if (
      item?.actionContent?.deliveredTo &&
      is.existy(item?.actionContent?.deliveredTo)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.deliveredTo,
        subTitle: item?.actionContent?.deliveredTo,
      });
    }

    return data;
  }

  private addCollectorImage(item: any) {
    if (
      item?.actionContent?.imageUrl &&
      is.existy(item?.actionContent?.imageUrl)
    ) {
      return [
        {
          type: "img",
          src: item?.actionContent?.imageUrl,
        },
      ];
    }

    return null;
  }

  private getJourneyData = (data: any) => {
    let arrayItems: any = [];
    let index = 0;

    data &&
      data.map((item: any) => {
        if (item && is.existy(item) && is.not.empty(item)) {
          arrayItems.push({
            key: index,
            headline:
              item?.displayTitle ?? changeCase.capitalCase(item?.action),
            headlineBackgroundColor: appCardConfig?.journey?.backgroundColor,
            date: moment(item?.createdAt).format("MMMM Do YYYY, h:mm:ss a"),
            children: [
              {
                title:
                  item?.displayTitle ?? changeCase.capitalCase(item?.action),
                subtitle: moment(item?.createdAt).format("lll") ?? "",
                multiColList: {
                  numberOfColumns: "2",
                  data: this.getJourneyChildData(item),
                },
                carouselItems: this.addCollectorImage(item),
                carouselStyles: {
                  width: "140px",
                  height: "180px",
                },
              },
            ],
          });
          index++;
        }
      });

    arrayItems = arrayItems.sort((a: any, b: any) => {
      return new Date(b.date) - new Date(a.date);
    });

    return {
      ...appCardConfig?.journey,
      data: arrayItems.reverse(),
    };
  };
  private getUserName(data: any) {
    if (data?.firstName) {
      return `${toHeaderCase(data?.firstName)} ${toHeaderCase(
        data?.lastName ?? " "
      )}`;
    }
  }

  private getButtons(remaining: any, delegateName: any, presentation: any) {
    let buttonArray: any = [
      {
        key: "downloadInvoice",
        title: "Print Invoice",
      },
      // {
      //   key: "optMailDelivery",
      //   title: "Mail Delivery",
      // },
    ];
    if (presentation != "preBooking") {
      console.log(presentation);
      buttonArray.push({
        key: "changeCostumeOptions",
        title: "Change Costume Options",
      });
    }
    if (remaining > 0) {
      buttonArray.push({
        key: "payOnline",
        title: "Pay Online",
      });
    }
    if (presentation != "preBooking") {
      if (delegateName === null) {
        buttonArray.push({
          key: "delegateName",
          title: "Add Delegate Name",
        });
      }
    }

    return buttonArray;
  }

  private _getCostumeValueDownPayment(items: any[]) {
    let totalDownPayment = 0;
    console.log(`items----`, items);
    if (items && Array.isArray(items)) {
      for (let i = 0; i < items.length; i++) {
        totalDownPayment += parseInt(items[i].costumeValue.minDownPayment || 0);
      }
      console.log(`totalDownPayment----`, totalDownPayment);
      return totalDownPayment;
    }
    return totalDownPayment;
  }
  private pastPurchaseArray(entireData: any) {
    const pastPurchaseArray: any = [];
    entireData.map((item: any) => {
      console.log(item),
        pastPurchaseArray.push({
          id: item?.presentation?.id,
          year: item?.presentation?.year,
          name: item?.presentation?.name,
          costumeStatus: item?.boxStatus,
          totalAmount: item?.totalAmount,
          amountPaid: item?.amountPaid,
          costumeId: item?.costumeID,
          section: item?.section?.name,
        });
    });
    console.log(pastPurchaseArray, "pastPurchaseArray");
    const pastPurchase = {
      headers: [
        "Year",
        "Presentation",
        "Action",
        "Section",
        "Costume ID",
        "Amount",
        "Costume Status",
      ],
      yearWiseDetails: pastPurchaseArray,
    };
    console.log(pastPurchase, "pastPurchase");
    return pastPurchase;
  }
  private formatData(data: any, year: any, entireData: any) {
    const d = new Date();
    let accordionItems: any = [];
    if (this.getTableData(data, data?.items)) {
      accordionItems.push(this.getTableData(data, data?.items));
    }
    console.log(accordionItems);
    if (
      data?.payOrder?.payTxes &&
      is.existy(data?.payOrder?.payTxes) &&
      is.not.empty(data?.payOrder?.payTxes)
    ) {
      console.log(year);
      accordionItems.push(this.getInvoiceData(data?.payOrder?.payTxes));
    }
    if (
      is.not.empty(
        this.getJourneyData(data?.boxTxes)?.data &&
          data?.presentation?.status === "active"
      )
    ) {
      accordionItems.push(this.getJourneyData(data?.boxTxes));
    }
    console.log(accordionItems);

    return {
      title: data?.items[0]?.costumeType?.name,
      authenticated:
        data?.delivery?.status === "Delivered" ? data?.delivery?.status : null,
      subtitle: data?.items[0]?.costumeType?.description,
      costumeTypeMinDownPayment:
        data?.items[0]?.costumeType?.minDownPayment ?? 0,
      costumeValueMinDownPayment: this._getCostumeValueDownPayment(data?.items),
      listItems: this.getListItems(data),
      carouselItems: this.getAllSectionImages(
        data?.items[0]?.costumeType,
        data?.items
      ),
      buttons:
        data?.presentation?.status === "active"
          ? this.getButtons(
              data?.totalAmount - (data?.amountPaid ?? 0),
              data?.delegateName,
              data?.presentation?.type
            )
          : [],
      accordionItems: accordionItems,
      paidAmount: data?.amountPaid ?? 0,
      totalAmount: data?.totalAmount,
      remainingAmount: data?.totalAmount - (data?.amountPaid ?? 0),
      userName: this.getUserName(data?.user) ?? "",
      userEmail: data?.user?.email ?? "",
      payOrderID: data?.payOrder?.id,
      currencyExchangeRate: this.exchangeRate,
      costumeID: data?.costumeID,
      boxId: data?.id,
      data: data,
    };
  }
}
